import Dialog from 'ui/dialog';
import 'ui/alert';
import 'ui/progress-spinner';
import 'style-loader!./modal.css';
import on from 'cadenza/utils/events';
import h from 'hyperscript';
import { phone } from 'cadenza/utils/media';

export default class Modal extends Dialog {

  constructor () {
    super();

    this.body = h('main.d-modal-body');
    this.footer = h('footer.d-modal-footer');

    this.form = h('form.d-modal-form', {
      autocomplete: 'off',
      onsubmit: event => {
        event.preventDefault();
        this.onSubmit(event);
      }
    }, [this.body, this.footer]);

    this.dialog.classList.add('d-modal');
    this.dialog.append(this.form);

    this.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.ctrlKey) {
        const submitButton = this.querySelector('[type=submit]');
        if (submitButton) {
          submitButton.focus();
          submitButton.click();
        }
      } else if (event.key === 'F11' && !(event.ctrlKey || event.shiftKey || event.metaKey) && this.querySelector('.fullscreen')) {
        event.preventDefault();
        this.fullscreen = !this.fullscreen;
      }
    });

    this.addEventListener('close', () => {
      this.resetAlert();
      this.setLoading(false);
    });

    on(this, 'click', '.fullscreen', () => {
      this.fullscreen = !this.fullscreen;
    });
  }

  connectedCallback () {
    this.dialog.classList.toggle('is-fullscreen', phone.matches);
    this.onMediaChange = onMediaChange.bind(this);
    phone.addListener(this.onMediaChange);
    super.connectedCallback();
  }

  disconnectedCallback () {
    if (this.onMediaChange) {
      phone.removeListener(this.onMediaChange);
      this.onMediaChange = null;
    }
    super.disconnectedCallback();
  }

  setLoading (loading, label) {
    const loadingBoolean = Boolean(loading);
    this.dialog.classList.toggle('is-loading', loadingBoolean);
    this.footer.hidden = loadingBoolean;

    if (this.loadingFooter) {
      this.loadingFooter.remove();
      this.loadingFooter = null;
    }

    if (loading) {
      this.loadingFooter = h('progress-spinner.d-modal-footer', {label});
      this.form.append(this.loadingFooter);

      if (loading.then) { // is thenable promise (do not rely on $.Deferred)
        const resetLoading = () => {
          if (loading === this.loading) {
            this.setLoading(false);
          }
        };
        loading.then(resetLoading, resetLoading);
      }

      this.loading = loading;
      this.onLoadingStart();
    } else {
      this.onLoadingEnd();
      this.loading = false;
    }
  }

  isLoading () {
    return Boolean(this.loading);
  }

  onLoadingStart () { }
  onLoadingEnd () { }
  onResize () { }
  onSubmit (event) { }

  setAlert (title, message, type) {
    if (this.alert) {
      this.alert.remove();
      this.alert = null;
    }
    if (title) {
      this.alert = h('d-alert.d-modal-alert', {title, message, type});
      this.form.insertBefore(this.alert, this.footer);
    }
  }

  hasAlert () {
    return Boolean(this.alert);
  }

  resetAlert () {
    this.setAlert('');
  }

  set fullscreen (value) {
    this.dialog.classList.toggle('is-fullscreen', value);
    this.onResize();
  }

  get fullscreen () {
    return this.dialog.classList.contains('is-fullscreen');
  }

}

function onMediaChange (event) {
  this.fullscreen = event.matches;
}

customElements.define('d-modal', Modal);
